import { createMuiTheme } from '@material-ui/core';
import { letClinicPalette, letClinicColors as colors } from '@lc/legacy/src/Theme';

export default createMuiTheme({
  overrides: {
    MuiPopover: {
      root: {
        zIndex: '5001 !important',
      },
    },
    MuiPickersBasePicker: {
      pickerView: {
        backgroundColor: '#F6F6F6',
        borderRadius: '4px',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        minHeight: '320px',
      },
    },
    MuiTypography: {
      body1: {
        color: colors.lightGreen,
        fontSize: '1.2rem',
        fontWeight: 'bold',
        lineHeight: '1.5',
        fontFamily: 'Montserrat',
      },
      body2: {
        fontWeight: 'bold',
        letterSpacing: '-0.06em',
        fontFamily: 'Montserrat',
      },
    },
    MuiIconButton: {
      root: {
        borderRadius: '0px',
        '&:disabled': {
          color: colors.lightGreen,
          opacity: '0.6',
        },
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        backgroundColor: '#F6F6F6',
      },
      iconButton: {
        color: colors.lightGreen,
      },
      dayLabel: {
        color: colors.gray79,
        width: '32px',
      },
    },
    MuiPickersCalendar: {
      week: {
        '& div': {
          borderLeft: `0.3px solid ${colors.grayA6}`,
          borderTop: `0.3px solid ${colors.grayA6}`,
          '&:last-child': {
            borderRight: `0.3px solid ${colors.grayA6}`,
          },
        },
        '&:last-child': {
          '& div': {
            borderBottom: `0.3px solid ${colors.grayA6}`,
          },
        },
      },
    },
    MuiPickersDay: {
      day: {
        color: colors.gray79,
        borderRadius: '0px',
        margin: 0,
      },
      daySelected: {
        color: colors.gray79,
        backgroundColor: 'rgba(52, 186, 146, 0.35)',
        '&:hover': {
          backgroundColor: 'rgba(52, 186, 146, 0.6)',
        },
      },
      dayDisabled: {
        color: colors.grayA6,
      },
      current: {
        color: colors.lightGreen,
      },
    },
  },
  palette: letClinicPalette,
});
